import React, { useState } from 'react';
import { useLanguage } from '../LanguageContext';
import './Header.css';

const Header: React.FC = () => {
  const { language, setLanguage, t } = useLanguage();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className="header">
      <div className="container">
        <nav className="nav">
          <div className="logo">
            <span className="logo-text">Box<span className="logo-accent">Flow</span></span>
            <span className="logo-icon">📦</span>
          </div>
          
          <button 
            className="mobile-menu-toggle"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>

          <div className={`nav-menu ${mobileMenuOpen ? 'active' : ''}`}>
            <a href="#services" className="nav-link">{t.nav.services}</a>
            <a href="#pricing" className="nav-link">{t.nav.pricing}</a>
            <a href="#about" className="nav-link">{t.nav.about}</a>
            <a href="#contact" className="nav-link">{t.nav.contact}</a>
            
            <div className="language-switcher">
              <button
                className={`lang-btn ${language === 'bg' ? 'active' : ''}`}
                onClick={() => setLanguage('bg')}
              >
                BG
              </button>
              <button
                className={`lang-btn ${language === 'en' ? 'active' : ''}`}
                onClick={() => setLanguage('en')}
              >
                EN
              </button>
            </div>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;

